import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImportServiceService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  ImportSizes(data: any) {
    const url = `${this.baseUrl + 'sizepricing/'}import`;
    return this.http.post(url, data);
  }

  ImportStoreStations(data: any) {
    const url = `${this.baseUrl + 'stations/'}import`;
    return this.http.post(url, data);
  }

  ImportQuality(data: any) {
    const url = `${this.baseUrl + 'grades/'}import`;
    return this.http.post(url, data);
  }

  ImportConditions(data: any) {
    const url = `${this.baseUrl + 'Conditions/'}import`;
    return this.http.post(url, data);
  }
}
